import React from "react";
import { string, func, arrayOf, shape, bool } from "prop-types";

import { withTabNavigation } from "@hoc/withTabNavigation";
import TopBarItem from "./TopBarItem";

const ListItem = withTabNavigation("li");

export const ActionItem = ({ onClick, title }) => (
  <ListItem
    className="
      inline-block px-2 py-1 transition duration-300
      text-white bg-primaryDark rounded-sm cursor-pointer
      text-sm/4 uppercase tracking-px font-semibold whitespace-nowrap
      hover:bg-primaryDarkAccent/10 hover:duration-150 hover:text-black
      max-smallMobile:px-1 max-smallMobile:text-xs/4
    "
    onClick={onClick}
  >
    {title}
  </ListItem>
);

const ItemSelector = ({ items, value, onClickItem, isDisabled }) => {
  const handleChange = selectedItemValue => {
    if (isDisabled) {
      return;
    }

    onClickItem?.(selectedItemValue);
  };

  return (
    <ul className="flex justify-start list-none m-0 gap-2">
      {items.map(item => {
        const isSelected = value === item.value;

        return (
          <TopBarItem
            key={item.value}
            isDisabled={isDisabled}
            isSelected={isSelected}
            onClick={() => handleChange(item.value)}
          >
            {item.title}
          </TopBarItem>
        );
      })}
    </ul>
  );
};

ActionItem.propTypes = {
  isDisabled: bool,
  isSelected: bool,
  onClick: func,
  title: string,
};

ItemSelector.propTypes = {
  items: arrayOf(
    shape({
      value: string,
      title: string,
    })
  ).isRequired,
  value: string,
  onClickItem: func,
  isDisabled: bool,
};

export default ItemSelector;
